import React, { Component, Fragment } from "react";
import ThisTable from "components/Common/ThisTable/index";
import moment from "moment";
import Gravatar from "react-gravatar";
import { getStatusColor } from "utils/statusColors.js";
import { Link, Route } from "react-router-dom";
import { ButtonActionsTable } from "components/Common/Buttons";
import _ from "lodash";

import CommonFilters from "components/Common/Filters/CommonFilters";
import permissionCheck from "utils/permissionCheck.js";
import { languageService } from "../../../Language/language.service";
import { statusStyle } from "../../JourneyPlan/JourneyPlanList/style";
import { themeService } from "../../../theme/service/activeTheme.service";
import { androidDoneAll } from "react-icons-kit/ionicons/androidDoneAll";
import {
  dateSort,
  generalSort,
  generalSortUsingArrayIndex,
  generalSortUsingStringAndNumbers,
  WorkerOrderPrioritySortSequence,
  WorkerOrderStateSortSequence,
} from "../../../utils/sortingMethods";
import { maintenanceOptions, getPriorityOptions, getMaintenanceOptionsValueToText } from "../../IssuesReports/IssuesList/IssuesList";
import { basicColors, retroColors, electricColors } from "../../../style/basic/basicColors";
import { checkmark } from "react-icons-kit/icomoon/checkmark";
import SvgIcon, { Icon } from "react-icons-kit";
import { LocPrefixService } from "../../LocationPrefixEditor/LocationPrefixService";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { formatIssueTimeStamp } from "../../../utils/issueDateUtil";
import { getIssueMPMethods } from "../../Common/services/mileposts";
import { mListHelper } from "./mListHelper";
import { versionInfo } from "../../MainPage/VersionInfo";
class MaintenanceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: this.props.pageSize ? this.props.pageSize : 30,
      page: this.props.page ? this.props.page : 0,
      selected: null,
      filteredData: [],
    };
    this.columns = [
      {
        Header: languageService("Actions"),
        id: "actions",
        filterable: false,
        accessor: (d) => {
          return (
            <div>
              {/* {permissionCheck('MAINTENANCE', 'read') && */}{" "}
              {permissionCheck("MAINTENANCE", "view") && (
                <Link to={`${this.props.path}s/` + d._id} className="linkStyleTable">
                  <ButtonActionsTable
                    handleClick={(e) => {
                      this.props.handleViewClick(d, this.state.filterTodayOrAll, this.props.pageSize);
                    }}
                    margin="0px 10px 0px 0px"
                    buttonText={languageService("View")}
                  />
                </Link>
              )}
              {mListHelper.mItemEditForm(d) && permissionCheck("MAINTENANCE", "update") && (
                <ButtonActionsTable
                  handleClick={() => {
                    this.props.editMaintenance("Edit", d);
                  }}
                  margin="0px 10px 0px 0px"
                  buttonText={languageService("Edit")}
                />
              )}
              {permissionCheck("MAINTENANCE", "view") && (
                <ButtonActionsTable
                  handleClick={(e) => {
                    this.props.handleNotesClick(d, this.state.filterTodayOrAll, this.props.pageSize);
                  }}
                  margin="0px 10px 0px 0px"
                  buttonText={languageService("Notes")}
                />
              )}
              {/* {(!d.workOrderNumber || d.workOrderNumber === "") &&
                permissionCheck("MAINTENANCE WORK ORDER", "view") &&
                d.status !== "Closed" && (
                  <ButtonActionsTable
                    handleClick={() => {
                      this.props.handlePlanClick(d);
                    }}
                    margin="0px 10px 0px 0px"
                    buttonText={languageService("Capital Plan")}
                  />
                )} */}
              {/* permissionCheck('MAINTENANCE', 'update') && */}
              {/* {((d.status === "Planned") && //"Inprogress" && d.status !== "Closed" && (
                <ButtonActionsTable
                  handleClick={e => {
                    //this.props.handleEditClick('Edit', d, this.state.filterTodayOrAll, this.props.pageSize)
                    this.props.handleExecuteClick(d); //, this.state.filterTodayOrAll, this.props.pageSize);
                  }}
                  margin="0px 10px 0px 0px"
                  buttonText={"Execute"}
                />
              )} */}
              {/* permissionCheck('MAINTENANCE', 'update') && */}
              {/* {((d.status === "In Progress") && //"Inprogress" && d.status !== "Closed" && (
                <ButtonActionsTable
                  handleClick={e => {
                    //this.props.handleEditClick('Edit', d, this.state.filterTodayOrAll, this.props.pageSize)
                    this.props.handleCloseClick(d); //, this.state.filterTodayOrAll, this.props.pageSize);
                  }}
                  margin="0px 10px 0px 0px"
                  buttonText={"Close"}
                />
              )} */}
              {/* {d.status !== "In Progress" && d.status !== "Finished" && permissionCheck("DELETE WORKORDER", "delete") && (
                <ButtonActionsTable
                  handleClick={(e) => {
                    this.props.handleDeleteClick(d);
                  }}
                  margin="0px 10px 0px 0px"
                  buttonText={"Delete"}
                />
              )} */}
            </div>
          );
        },
        minWidth: 120,
      },
      {
        id: "mrnumber",
        Header: "MR#",
        minWidth: 100,
        accessor: (d) => {
          if (d.mrNumber) return d.mrNumber;

          return "";
        },
      },

      {
        id: "issueNum",
        Header: languageService("Issue#"),
        minWidth: 100,
        show: versionInfo.isLAMP() ? false : true,
        accessor: (d) => {
          if (d.issue && d.issue.serverObject && d.issue.serverObject.issueNum) return d.issue.serverObject.issueNum;

          return "N/A";
        },
      },
      {
        Header: languageService("Created By"),
        id: "createdBy",
        width: 130,
        accessor: (d) => {
          let createdBy = "";
          if (d.createdBy) {
            createdBy = d.createdBy.name;
          }
          return createdBy;
        },
      },
      {
        Header: languageService("Asset Name"),
        title: "trackId",
        accessor: (d) => {
          if (d.issue && d.issue.unit && d.issue.unit.unitId) {
            return d.issue.unit.unitId;
          }
          return "N/A";
        },
        searchType: versionInfo.isReVAMP() ? "dropDown" : "",
        id: "trackId",
        minWidth: 150,
      },

      {
        Header: languageService("Asset Type"),
        title: "assetType",
        searchType: "dropDown",
        accessor: (d) => {
          if (d.issue && d.issue.unit && d.issue.unit.assetType) {
            return languageService(d.issue.unit.assetType);
          }
          return "N/A";
        },
        id: "assetType",
        minWidth: 150,
        applicationType: ["TIMPS", "SITE"],
      },
      {
        Header: languageService("Maintenance Type"),
        id: "mType",
        width: 130,
        accessor: (d) => {
          let mType = "";
          if (d.maintenanceType) {
            mType = d.maintenanceType;
          }
          return mType;
        },
      },
      versionInfo.isLAMP() && {
        Header: languageService("Description"),
        id: "description",
        minWidth: 200,
        accessor: (d) => {
          if (d.issue && d.issue.description) {
            return d.issue.description;
          }
          return "";
        },
      },
      {
        Header: languageService("Defect MP"),
        id: "mp",
        accessor: (d) => {
          if (d.issue) return getIssueMPMethods.getIssueMPMarkerValue(d.issue, d.lineId);
          else return "N/A";
        },
        sortMethod: (a, b) => {
          const getFirstNumber = (str) => {
            const match = str.split(",");
            let x = match ? parseFloat(match[0]) : Number.POSITIVE_INFINITY;
            if (isNaN(x)) {
              return Number.POSITIVE_INFINITY;
            }
            return x;
          };

          const firstNumberA = getFirstNumber(a);
          const firstNumberB = getFirstNumber(b);
          return firstNumberA - firstNumberB;
        },
        minWidth: 120, //150,
      },
      {
        Header: languageService("Defect Codes"),
        id: "defect",
        width: 150,
        show: versionInfo.isLAMP() ? false : true,
        accessor: (d) => {
          let defectCount = 0;
          let defectCodes = d && d.issue && d.issue.defectCodes;
          let defectDescription = d.issue.description;
          if (defectCodes && defectCodes.length > 0) {
            defectCodes = defectCodes.filter((dc) => dc !== "");
            defectCount = defectCodes.length;
            return defectDescription;
          } else {
            return defectDescription ? `Def: ${defectDescription}` : "N/A";
          }
        },
        Cell: (_props) => {
          const { original, value } = _props;
          const d = original;
          let defectCount = 0;
          let defectCodes = d && d.issue && d.issue.defectCodes;
          let defectDescription = d.issue.description;
          if (defectCodes && defectCodes.length > 0) {
            defectCodes = defectCodes.filter((dc) => dc !== "");
            defectCount = defectCodes.length;
            return (
              <div id={"defect"} className="defect-code-button" style={{ textAlign: "center" }}>
                <span
                  style={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    height: "17px",
                    display: "inline-block",
                    whiteSpace: "nowrap",
                    maxWidth: "100%",
                    width: "315px",
                  }}
                >
                  {defectDescription}
                </span>
              </div>
            );
          } else {
            return <div style={{ textAlign: "center" }}>N/A</div>;
          }
        },
        style: { whiteSpace: "unset" },
      },
      versionInfo.isChargeCodeField() && {
        Header: languageService("Charge Code"),
        id: "chargeCode",
        width: 130,
        accessor: (d) => {
          let charge_Code = "";
          if (d.chargeCode && d.chargeCode.length > 0) {
            return (charge_Code = d.chargeCode);
          } else {
            return "N/A";
          }
        },
      },
      {
        Header: languageService("Date Created"),
        id: "timestamp",
        minWidth: 120,
        sortMethod: dateSort,
        accessor: (d) => {
          let date = "";
          if (d.issue && d.issue.remedialAction && d.issue.remedialAction === "Repaired" && d.issue.timeStamp) {
            return formatIssueTimeStamp(d.issue.timeStamp);
          }
          if (d.createdAt) {
            date = moment(d.createdAt).format("MM/DD/YYYY h:mm A");
          }
          return date;
        },
        Cell: (_props) => {
          const { original, value } = _props;
          const d = original;
          let date = "";
          if (d.issue && d.issue.remedialAction && d.issue.remedialAction === "Repaired" && d.issue.timeStamp) {
            return moment.utc(d.issue.timeStamp).local().format("llll");
          }
          if (d.createdAt) {
            date = moment(d.createdAt).format("llll");
          }
          return date;
        },
      },
      {
        Header: languageService("Days Since Reported"),
        id: "daysSince",
        minWidth: 120,
        accessor: (d) => {
          if (d.status === "Closed" || d.status === "Complete") {
            return d.status;
          } else if (d.issue && d.issue.timeStamp) {
            const startDate = moment(formatIssueTimeStamp(d.issue.timeStamp));
            const endDate = moment(new Date());
            var duration = moment.duration(endDate.diff(startDate));
            let days = duration.asDays();
            if (days < 0) days = 0;
            else if (days < 0.25 || days > 1) {
              days = Math.floor(days);
            } else {
              days = days.toFixed(2);
            }
            return days;
          } else return "";
        },
        sortMethod: generalSortUsingStringAndNumbers,
        Cell: (_props) => {
          const { original, value } = _props;
          let timeStamp = original.issue && original.issue.timeStamp ? formatIssueTimeStamp(original.issue.timeStamp) : "";

          return timeStamp ? (
            <span>
              <TooltipContainer
                tooltipText={
                  <span>
                    {languageService("Issue reported on")}: <br /> {timeStamp}
                  </span>
                }
              >
                {value}
              </TooltipContainer>
            </span>
          ) : (
            <div>{value}</div>
          );
        },
      },
      {
        id: "review",
        Header: languageService("State"),
        accessor: (d) => {
          let woReviewStates = this.props.woReviewStates || [];

          let match =
            woReviewStates.find(function (s) {
              return s.code === d.reviewState;
            }) ||
            woReviewStates.find(function (s) {
              return s.code === "Others";
            });

          if (d.status === "Complete") {
            const closedMatch =
              woReviewStates.find((s) => s.displayVal === "Closed") || woReviewStates.find((s) => s.displayVal === "Accepted");
            if (closedMatch && closedMatch.displayVal) return closedMatch.displayVal;
            return "Closed";
          }

          return match && match.displayVal && match.displayVal;
        },
        searchType: "dropDown",
        applicationType: ["TIMPS"],
        show: false,
      },
      {
        id: "locLine",
        Header: languageService("Location"),
        minWidth: 200,
        accessor: (d) => {
          if (d.lineName) return d.lineName;

          return "";
        },
      },
      {
        Header: languageService("Assign Maintenance"),
        id: "issueMaintenance",
        filterable: false,
        width: 150,
        show: versionInfo.isLAMP() ? false : this.props.forDashboard ? false : true,
        accessor: (d) => {
          return d.maintenanceRole;
        },
        Cell: (_props) => {
          const { original, value } = _props;
          const d = original;
          const maintenanceRole = d.maintenanceRoleToUpdate ? d.maintenanceRoleToUpdate : value;

          let UpdateMaintenanceRequired = d.maintenanceAction === "maintenanceMode";
          let changeable =
            d.status == "In Progress" || d.status == "Closed" || d.status == "Complete" || !permissionCheck("MAINTENANCE", "create")
              ? false
              : true;

          return (
            <div>
              {changeable && (
                <React.Fragment>
                  <div style={{ display: "inline-block", width: "80%" }}>
                    <select
                      disabled={false}
                      onChange={(e) => {
                        props.handleUpdateMaintenance(d._id, e.target, "updateMaintenanceRole");
                      }}
                      name="maintenanceRole"
                      value={maintenanceRole || ""}
                    >
                      {maintenanceOptions(maintenanceRole && maintenanceRole !== "Issue")}
                    </select>
                    {UpdateMaintenanceRequired && (
                      <div style={{ display: "inline-block" }}>
                        <div
                          style={themeService({
                            default: { color: basicColors },
                            retro: { color: "var(--second)" },
                            electric: { color: electricColors.second },
                          })}
                        >
                          <SvgIcon
                            size={15}
                            icon={checkmark}
                            onClick={(e) => props.handleUpdateMaintenance(d._id, e.target, "saveMaintenanceRole")}
                            style={{
                              marginRight: "5px",
                              marginLeft: "5px",
                              verticalAlign: "middle",
                              cursor: "pointer",
                              zIndex: "10",
                              position: "relative",
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}
              {!changeable && <React.Fragment>{languageService(getMaintenanceOptionsValueToText(d.maintenanceRole))}</React.Fragment>}
            </div>
          );
        },
      },
      {
        Header: languageService("Plan Date"),
        id: "dueDate",
        minWidth: 100,
        show: versionInfo.isLAMP() ? false : true,
        accessor: (d) => {
          let date = "";
          if (d.dueDate) {
            // date = new Date(d.dueDate).getTime();
            date = moment(d.dueDate).format("MM/DD/YYYY h:mm A");
          }
          return date;
        },
        Cell: (_props) => {
          const { original, value } = _props;
          const d = original;
          let date = "";
          if (d.dueDate) {
            date = moment(d.dueDate).format("ll");
          }
          return date;
        },
      },
      // {
      //   Header: languageService("Execution Date"),
      //   id: "executionDate",
      //   minWidth: 150,
      //   // sortMethod: dateSort,
      //   accessor: (d) => {
      //     let date = "";
      //     if (d.executionDate) {
      //       date = moment(d.executionDate).format("ll");
      //     }
      //     return date;
      //   },
      // },
      {
        Header: languageService("Date Closed"),
        id: "closedDate",
        minWidth: 100,
        accessor: (d) => {
          let date = "";
          if (d.closedDate) {
            // date = new Date(d.closedDate).getTime();
            date = moment(d.closedDate).format("MM/DD/YYYY h:mm A");
          }
          return date;
        },
        Cell: (_props) => {
          const { original, value } = _props;
          const d = original;
          let date = "";
          if (d.closedDate) {
            date = moment(d.closedDate).format("llll");
          }
          return date;
        },
      },
      {
        _Header: languageService("Priority"),
        Header: () => {
          return (
            <div style={{ display: "inline-block" }}>
              {languageService("Priority")}
              {this.props.wosPriorityToUpdateCount > 0 ? (
                <div
                  style={{ display: "inline-block" }}
                  id="select-all"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.updateWosPriorityBatchAssign();
                  }}
                >
                  <SvgIcon
                    size={23}
                    icon={androidDoneAll}
                    style={{
                      marginRight: "5px",
                      marginLeft: "5px",
                      verticalAlign: "middle",
                      cursor: "pointer",
                      zIndex: "10",
                      position: "relative",
                      color: "rgb(224, 44, 73)",
                    }}
                  />
                </div>
              ) : null}
            </div>
          );
        },

        id: "priority",
        filterable: false,
        width: 130,
        sortMethod: (a, b) =>
          generalSortUsingArrayIndex(
            a,
            b,
            [...this.props.priorityList]
              .sort((a, b) => {
                if (typeof a.viewOrder === "number" && typeof b.viewOrder === "number") {
                  return a.viewOrder - b.viewOrder;
                }
                return 0;
              })
              .map((l) => l.priority),
          ),
        accessor: (d) => {
          let priority = "";
          if (d.priority) {
            priority = d.priority;
          }
          return priority;
        },
        Cell: (_props) => {
          const { original, value } = _props;
          const d = original;
          const priority = d.priorityToUpdate ? d.priorityToUpdate : value;
          let foundPriorityList = this.props.priorityList.find((l) => l.priority === priority);
          const color = foundPriorityList ? foundPriorityList.color : null;

          let UpdateMaintenanceRequired = d.maintenanceAction === "updatePriorityRequired";
          let changeable = d.status == "Closed" || d.status == "Complete" ? false : true;

          return (
            <div>
              {changeable && (
                <React.Fragment>
                  <div
                    style={
                      priority === "" ? { textAlign: "center" } : themeService(statusStyle.statusColorStyle(priority, this.props, color))
                    }
                  >
                    <select
                      disabled={false}
                      onChange={(e) => {
                        props.handleUpdateMaintenance(d._id, e.target, "updatePriority");
                      }}
                      name="issuePriority"
                      value={priority || ""}
                    >
                      {getPriorityOptions(
                        priority,
                        this.props.priorityList.map((l) => l.priority),
                      )}
                    </select>
                    {UpdateMaintenanceRequired && (
                      <div style={{ display: "inline-block" }}>
                        <div
                          style={themeService({
                            default: { color: basicColors },
                            retro: { color: "var(--second)" },
                            electric: { color: electricColors.second },
                          })}
                        >
                          <SvgIcon
                            size={15}
                            icon={checkmark}
                            onClick={(e) => {
                              props.handleUpdateMaintenance(d._id, e.target, "savePriority");
                            }}
                            style={{
                              marginRight: "5px",
                              marginLeft: "5px",
                              verticalAlign: "middle",
                              cursor: "pointer",
                              zIndex: "10",
                              position: "relative",
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}
              {!changeable && priority && priority !== "" && (
                <div style={themeService(statusStyle.statusColorStyle(priority, this.props, color))}>{languageService(priority)}</div>
              )}
            </div>
          );
        },
      },
      {
        Header: languageService("Status"),
        id: "status",
        width: 130,
        sortMethod: (a, b) => generalSortUsingArrayIndex(a, b, WorkerOrderStateSortSequence),
        accessor: (d) => {
          let status = "Unknown";
          if (d.status) {
            status = d.status;
          }
          return status;
        },
        Cell: (_props) => {
          const { value } = _props;

          return <div style={themeService(statusStyle.statusColorStyle(value, this.props))}>{languageService(value)}</div>;
        },
      },
    ].filter(Boolean);
    this.handlePageSave = this.handlePageSave.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.actionType == "MAINTENANCES_READ_SUCCESS" && this.props.maintenanceData) {
      let l = this.props.maintenanceData.length;
      if (l != this.state.dataLength && l > 0) {
        //console.log('MaintenanceList->componentDidUpdate', this.props.maintenanceData);
        this.setState({
          filteredData: this.props.maintenanceData,
          dataLength: l,
        });
      }

      if (this.props.page != prevProps.page) {
        this.setState({
          page: this.props.page ? this.props.page : 0,
        });
      }
    }
    // console.log('maintenancelist->componentdidupdate', this.props.maintenanceData);
    // console.log(prevProps.actionType !== this.props.actionType, this.props.actionType=='MAINTENANCES_READ_SUCCESS', this.props.maintenanceData.length);
    // if(prevProps.actionType !== this.props.actionType && this.props.actionType=='MAINTENANCES_READ_SUCCESS')
    // {
    //     if(this.props.maintenanceData.length > 0)
    //     {
    //         console.log('MaintenanceList->componentDidUpdate', this.props.maintenanceData);
    //        // console.log('got data in maintenance list componentdidupdate', this.props.maintenaceData);
    //         this.setState({filteredData: this.props.maintenaceData});
    //     }
    // }
  }
  handlePageSave(page, pageSize) {
    this.setState({
      page: page,
      pageSize: pageSize,
    });

    this.props.handlePageNumber(page);
  }
  render() {
    const applicationType = versionInfo.getApplicationType();
    let columns = this.columns;
    if (this.props.noActionColumn) {
      _.remove(this.columns, { id: "actions" });
    }

    if (versionInfo.isReVAMP()) {
      _.remove(columns, { id: "mp" });
    }

    return (
      <div>
        {!this.props.noFilter && (
          <CommonFilters
            showFilters={true}
            noFilters
            tableInFilter
            //checkTodayAllFilter={this.props.checkTodayAllFilter}
            downloadToCsv={this.props.downloadToCsv}
            showCustomFilter
            customFilterComp={this.props.customFilterComp}
            tableColumns={columns}
            tableData={this.props.maintenanceData}
            pageSize={this.state.pageSize}
            pagination={true}
            handlePageSave={this.handlePageSave}
            page={this.state.page}
            handlePageSize={this.props.handlePageSize}
            defaultSorted={[{ id: "mrnumber", desc: true }]}
            rowStyleMap={this.props.rowStyleMap}
            exportToCsv={this.props.exportToCsv}
            tableFilters={this.props.tableFilters}
            handleTableFiltersChange={this.props.handleTableFiltersChange}
            applicationType={applicationType}
          />
        )}
      </div>
    );
  }
}

export default MaintenanceList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceList/index.jsx